const opts = [
  { value: 'Spouse', label: 'Spouse' },
  { value: 'Son', label: 'Son' },
  { value: 'Daughter', label: 'Daughter' },
  { value: 'Father', label: 'Father' },
  { value: 'Mother', label: 'Mother' },
  { value: 'Brother', label: 'Brother' },
  { value: 'Sister', label: 'Sister' },
  { value: 'Grand-Son', label: 'Grand-Son' },
  { value: 'Grand-Daughter', label: 'Grand-Daughter' },
  { value: 'Grand-Father', label: 'Grand-Father' },
  { value: 'Grand-Mother', label: 'Grand-Mother' },
  // { value: 'Not Provided', label: 'Not Provided' },
  { value: 'Others', label: 'Others' },
];

const titleOptions = [
  { value: 'Mr', label: 'Mr' },
  { value: 'Mrs', label: 'Mrs' },
  { value: 'Miss', label: 'Miss' },
  { value: 'M/S', label: 'M/S' },
  { value: 'Ms', label: 'Ms' },
]

const optArr = opts.reduce((acc: any, ele: any) => [...acc, ele.value], []);
const titleOptionsArr = titleOptions.reduce((acc: any, ele: any) => [...acc, ele.value], []);

export {
  optArr, titleOptionsArr, opts, titleOptions,
};
